export default {
  subscriptions: (state, getters, { entities }) =>
    state.ids.map((id) => entities.subscriptions.byId[id]),
  subscription: (state, getters, { entities }) =>
    state.current ? entities.subscriptions.byId[state.current] || null : null,
};
